module.exports = __webpack_public_path__ + "img/5_4.eec96eac.jpg";